"use strict";

const loginForm = $('.cc-clerkUser #storeAppLoginForm');
const searchForm = $('.cc-clerkUser #storeAppSearchForm');
const beginServiceForm = $('.cc-clerkUser #storeAppBeginService');
const phoneInput = $('.cc-clerkUser #registration-form-phone');
const wrongAuth = $('.cc-clerkUser #clerk-auth-failed');
const wrongRegistration = $('.cc-clerkUser #customerRegistrationError');
const wrongEmail = $('#easyForm #form-email-confirm-error');
const wrongPhone = $('#easyForm #form-phone-error');
const wrongLogout = $('.cc-clerkUser #clerk-logout-failed');
const wrongNoCustomersFound = $('.cc-clerkUser #noCustomersFound');
const clerkLogoutBtn = $('.cc-clerkUser #cta-clerkLogout');
const clerkServiceBtn = $('.cc-clerkUser #clerk-service');
const chooseCustomerBtn = $('.cc-clerkUser #clerk-choose-customer');
const logoutCustomerBtn = $('.cc-clerkUser #storeAppBeginService #logoutCustomer');
const loginCustomerBtn = $('.cc-clerkUser #storeAppBeginService #loginCustomer');
const registrationBtn = $('.cc-clerkUser #service-modal-registerCustomer');
const easyForm = $('.cc-clerkUser #easyForm');
let phoneNumberError = false;

/* ACTIONS ON LOAD */
$(document).ready(function () {

    /* GET STORES FOR SELECT */
    getStores()

    /* HANDLE FORMS */
    handleFormsOnLoad();

    /* HANDLE BUTTONS */
    handleButtonsOnload();

});

/* LOGIN FORM */
loginForm.on('submit', function (event) {

    event.preventDefault();
    if ($.spinner()) $.spinner().start();

    wrongAuth.addClass('d-none');

    var form = $(this);
    var formData = $(this).serializeArray();
    var jsonData = {};
    $.each(formData, function () {
        jsonData[this.name] = this.value;
    });

    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: form.attr('action'),
        data: JSON.stringify(jsonData),
        success: function (response) {

            if (response.httpStatus == 200 & response.status == 'authorize') {
                // Remove objects from sessionStorage
                clearSessionStorage(['employee', 'customer', 'loggedcustomer', 'disablesearchform']);
                sessionStorage.setItem('employee', JSON.stringify(response.associateInfo));
                localStorage.setItem('clerkStore', response.associateInfo.storeId);
                location.reload();
            } else {
                wrongAuth.removeClass('d-none');
                if ($.spinner()) $.spinner().stop();
            }

        },
        error: function (error) {
            console.error('Error on agent login: ', error);
            if ($.spinner()) $.spinner().stop();
            wrongAuth.removeClass('d-none');
        }
    }).fail(function () {
        if ($.spinner()) $.spinner().stop();
        wrongAuth.removeClass('d-none');
    });
});

/* LOGOUT FORM */
clerkLogoutBtn.on('click', function (event) {

    if ($.spinner()) $.spinner().start();

    let url = $(this).data('href')

    $.ajax({
        type: 'POST',
        url: url,
        success: function (response) {

            if (response.httpStatus == 200 && !response.error) {

                // Remove objects from sessionStorage
                clearSessionStorage(['employee', 'customer', 'loggedcustomer', 'disablesearchform']);

                window.location.href = $('.cc-clerkUser #clerk-service').data('homeurl');
            } else {
                wrongLogout.removeClass('d-none');
                if ($.spinner()) $.spinner().stop();
            }

        },
        error: function (error) {
            console.error('Error on agent logout: ', error);
            if ($.spinner()) $.spinner().stop();
            wrongLogout.removeClass('d-none');
        }
    }).fail(function () {
        if ($.spinner()) $.spinner().stop();
        wrongLogout.removeClass('d-none');
    });

});

/* CUSTOMER LOGOUT BTN */
logoutCustomerBtn.on('click', function (event) {

    if ($.spinner()) $.spinner().start();

    let url = $(this).data('href')

    $.ajax({
        type: 'GET',
        url: url,
        success: function (response) {

            if (response.httpStatus == 200) {

                // Remove objects from sessionStorage
                clearSessionStorage(['customer', 'loggedcustomer', 'disablesearchform']);

                window.location.href = response.continueURL;
            } else {
                wrongLogout.removeClass('d-none');
                if ($.spinner()) $.spinner().stop();
            }

        },
        error: function (error) {
            console.error('Error on customer logout: ', error);
            if ($.spinner()) $.spinner().stop();
            wrongLogout.removeClass('d-none');
        }
    }).fail(function () {
        if ($.spinner()) $.spinner().stop();
        wrongLogout.removeClass('d-none');
    });

});

/* GET EMPLOYEE/CUSTOMER FROM STORAGE AND SHOW INFO ON DOM */
$(document).ready(function () {

    if ($.spinner()) $.spinner().start();

    if (clerkServiceBtn.length > 0) {

        let loggedEmployee = sessionStorage.getItem('employee')
        if (loggedEmployee) {
            let firstName = JSON.parse(loggedEmployee).firstName;
            let lastName = JSON.parse(loggedEmployee).lastName;
            lastName = lastName.split(' ').length == 1 ? `${lastName[0]}` : `${lastName.split(' ')[0][0]}.${lastName.split(' ')[1][0]}`
            $('.js-logged-employee .js-employee-name').text(`${firstName[0].toUpperCase()}. ${lastName.toUpperCase()}.`)
        }

        let choosenCustomer = sessionStorage.getItem('customer')
        if (choosenCustomer) {
            $('#storeAppService #customerInput').val(JSON.parse(choosenCustomer).login);
        }

        clerkServiceBtn.removeAttr('disabled');

    }
    if ($.spinner()) $.spinner().stop();

});

/* SEARCH FORM */
searchForm.on('submit', function (event) {

    event.preventDefault();
    if ($.spinner()) $.spinner().start();

    wrongNoCustomersFound.addClass('d-none');

    let url = $(this).data('url')
    let form = $(this);

    // CHECK INPUT VALUE TYPE
    let params = '';
    let searchInput = form.find('#searchInput').val();
    let checkName = searchInput.split(' ');
    let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (searchInput.includes('@')) {
        let checkEmail = emailPattern.test(searchInput)
        if (checkEmail) {
            params = `?email=${encodeURIComponent(searchInput)}`;
        } else {
            console.error('invalid email pattern');
        }

    } else if (checkName.length > 1) {

        if (checkName.length == 2) { params = `?firstname=${checkName[0]}&lastname=${checkName[1]}` }
        if (checkName.length == 3) { params = `?firstname=${checkName[0]}&lastname=${checkName[1] + '%20' + checkName[2]}` }

    } else {
        params = `?cardvirtualnumber=${searchInput}`;
    }

    $.ajax({
        type: 'GET',
        url: url + params,
        success: function (response) {

            if (response.httpStatus == 200 && response.customers.length > 0) {
                fillCustomers(response.customers);
                chooseCustomerBtn.trigger('click');
            } else {
                wrongNoCustomersFound.removeClass('d-none');
            }

            if ($.spinner()) $.spinner().stop();
        },
        error: function (error) {
            console.error('Error on agent login: ', error);
            if ($.spinner()) $.spinner().stop();
            wrongNoCustomersFound.removeClass('d-none');
        }
    }).fail(function () {
        if ($.spinner()) $.spinner().stop();
        wrongNoCustomersFound.removeClass('d-none');
    });
});

/* BEGIN SERVICE FORM */
beginServiceForm.on('submit', function (event) {

    event.preventDefault();
    if ($.spinner()) $.spinner().start();

    var form = $(this);
    var formData = $(this).serializeArray();
    var jsonData = {};
    $.each(formData, function () {
        jsonData[this.name] = this.value;
    });

    let clerkInfo = sessionStorage.getItem('employee') ? JSON.parse(sessionStorage.getItem('employee')) : {}
    if(clerkInfo) $.extend(jsonData, clerkInfo);

    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: form.data('url'),
        data: JSON.stringify(jsonData),
        success: function (response) {

            if (response.httpStatus == 200) {
                response.login = response.email;
                sessionStorage.setItem('customer', JSON.stringify(response));
                sessionStorage.setItem('loggedcustomer', JSON.stringify(response));
                sessionStorage.setItem('disablesearchform', JSON.stringify({ disabled: true }))
                location.reload();
            } else {
                // wrongAuth.removeClass('d-none');
                if ($.spinner()) $.spinner().stop();
            }

        },
        error: function (error) {
            console.error('Error on agent login: ', error);
            if ($.spinner()) $.spinner().stop();
            // wrongAuth.removeClass('d-none');
        }
    }).fail(function () {
        if ($.spinner()) $.spinner().stop();
        // wrongAuth.removeClass('d-none');
    });
});

/* EASY FORM REGISTRATION */
easyForm.on('submit', function (event) {

    event.preventDefault();
    event.stopImmediatePropagation();
    if ($.spinner()) $.spinner().start();

    // CLEAR ERRORS
    clearFormErrors()

    var form = $(this);

    // VALIDATE FORM
    let formValidation = validateForm(form);
    if(!formValidation){
        if ($.spinner()) $.spinner().stop();
        return;
    } 

    var formData = $(this).serializeArray();
    var jsonData = {};
    $.each(formData, function () {
        jsonData[this.name] = this.value;
    });

    let authUrl = form.data('authurl');
    let baseUrl = 'baseurl=' + window.location.hostname;

    if(jsonData.dwfrm_easyForm_customer_email != jsonData.dwfrm_easyForm_customer_emailconfirm){
        wrongEmail.addClass('d-block');
        wrongEmail.text(wrongEmail.data('errormsg'));
        if ($.spinner()) $.spinner().stop();
        return;
    }

    if(jsonData.dwfrm_easyForm_customer_phone){
        let phone = jsonData.dwfrm_easyForm_customer_phone;
        if(!phone.length == 12 || /^\d+$/.test(phone) == false){
            wrongPhone.addClass('d-block');
            wrongPhone.text(wrongPhone.data('errormsg'));
            if ($.spinner()) $.spinner().stop();
            return;
        }
    }

    try {

        $.ajax({
            type: 'GET',
            url: authUrl + '?' + baseUrl,
            success: function (response) {

                if (response.success) {
                    var postData = {
                        "password": 'A' + generateRandomString(16) + '!2',
                        "customer": {
                            "login": jsonData.dwfrm_easyForm_customer_email,
                            "first_name": jsonData.dwfrm_easyForm_customer_firstname,
                            "last_name": jsonData.dwfrm_easyForm_customer_lastname,
                            "email": jsonData.dwfrm_easyForm_customer_email,
                            "birthday": jsonData.dwfrm_easyForm_customer_birthday,
                            "gender": +jsonData.dwfrm_easyForm_customer_gender,
                            "phone_home": jsonData.dwfrm_easyForm_customer_phone,
                            "phone_mobile": jsonData.dwfrm_easyForm_customer_phone,
                            "c_accept1": true,
                            "c_accept2": true,
                            "c_privacyPolicy": true
                        }
                    }

                    $.ajax({
                        url: `${window.location.origin}${response.registrationEndpoint}?client_id=${response.clientId}`,
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(postData),
                        headers: {
                            'Authorization': response.bearerToken,
                            'x-dw-client-custom-type': 'storeapp'
                        },
                        success: function (response, textStatus, jqXHR) {
                            var statusCode = jqXHR.status;
                            if (statusCode == 200 && response.auth_type == 'registered') {
                                $('#easyForm .cc-modal__close').trigger('click');
                                $('#easyForm #registrationSuccess').trigger('click');
                                form.trigger('reset');
                                if ($.spinner()) $.spinner().stop();
                            }
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            if ($.spinner()) $.spinner().stop();
                            wrongRegistration.removeClass('d-none');
                            console.error('Error:', textStatus, errorThrown);
                        }
                    });
                } else {
                    console.error('Service authentication failed');
                    if ($.spinner()) $.spinner().stop();
                }

            },
            error: function (error) {
                if ($.spinner()) $.spinner().stop();
                wrongRegistration.removeClass('d-none');
                console.error('Error on agent login: ', error);
            }
        }).fail(function () {
            if ($.spinner()) $.spinner().stop();
            wrongRegistration.removeClass('d-none');
        });

    } catch (error) {
        if ($.spinner()) $.spinner().stop();
        wrongRegistration.removeClass('d-none');
        console.error('Catch error: ', error);
    }


});

/* HELPERS */
function getStores() {
    try {

        let ctaLogin = $('.cc-clerkUser #clerk-login');

        if (ctaLogin.length > 0) {

            let url = ctaLogin.data('getstores');

            $.ajax({
                type: 'GET',
                url: url,
                success: function (response) {

                    let storesList = response.JSONResponse.stores
                    $.each(storesList, function (i, item) {
                        $('.cc-clerkUser .js-stores-select').append($('<option>', {
                            value: item.value,
                            text: item.label
                        }));
                    });

                    if(localStorage.getItem('clerkStore')){
                        var selectedStore = localStorage.getItem('clerkStore');
                        $('.cc-clerkUser .js-stores-select').val(selectedStore);
                    }

                    ctaLogin.removeAttr('disabled');

                },
                error: function (error) {
                    console.error('Error retrieving stores: ', error);
                }
            }).fail(function () {
            });
        }

    } catch (error) {
        console.error('Error retrieving stores: ', error);
    }
}

function updateURLParameter(url, param, paramVal) {
    var urlObj = new URL(url);
    urlObj.searchParams.set(param, paramVal);
    return urlObj.toString();
}

function fillCustomers(customers) {
    let elementToFill = $('#storeAppChooseCustomer .list-group');
    let birthdayLabel = elementToFill.data('birthdaylabel');
    let html = '';

    customers.forEach(customer => {
        html += `
            <button type="button" class="list-group-item list-group-item-action" 
                    data-firstname="${customer.first_name}" 
                    data-lastname="${customer.last_name}" 
                    data-email="${customer.email}" 
                    data-customerno="${customer.customer_no}"
                    data-login="${customer.login}"
                    data-birthday="${formatDate(customer.birthday)}"
                    data-cardvirtualnumber="${customer.card_virtual_number}"
                    data-phone="${customer.phone_home}">
                <div class="d-none d-sm-flex w-100 justify-content-between">
                    <h5 class="mb-1">${customer.first_name} ${customer.last_name}</h5>
                    <small>${birthdayLabel}</small>
                </div>
                <div class="d-none d-sm-flex w-100 justify-content-between">
                    <h5 class="mb-1">${customer.email}</h5>
                    <small>${formatDate(customer.birthday)}</small>
                </div>
                <div class="d-flex flex-column d-sm-none w-100">
                    <h5 class="mb-1">${customer.first_name} ${customer.last_name}</h5>
                    <h5 class="mb-1">${customer.email}</h5>
                    <small>${birthdayLabel}</small>
                    <small>${formatDate(customer.birthday)}</small>
                </div>
            </button>
        `
    });

    elementToFill.html(html)

    const chooseCustomerGroupBtn = $('#storeAppChooseCustomer .list-group-item-action');
    chooseCustomerGroupBtn.on('click', function (e) {
        let customer = {
            customer_no: e.currentTarget.dataset.customerno,
            email: e.currentTarget.dataset.email,
            first_name: e.currentTarget.dataset.firstname,
            last_name: e.currentTarget.dataset.lastname,
            login: e.currentTarget.dataset.login,
            birthday: e.currentTarget.dataset.birthday,
            card_virtual_number: e.currentTarget.dataset.cardvirtualnumber,
            phone_home: e.currentTarget.dataset.phone
        }

        fillCustomerConfirm(customer);
        $('#chooseCustomer #confirm-customer').trigger('click');
    });

}

function fillCustomerChoosen(customer) {
    $('#storeAppService #customerInput').val(customer.login);
}

function fillCustomerConfirm(customer) {
    let elementToFill = $('.cc-clerkUser #confirmCustomer .confirmCustomerList');
    let html = '';

    if (customer.first_name) html += `<li class="list-group-item"><span class="col-4">nome</span> <span class="col-8">${customer.first_name}</span></li>`;
    if (customer.last_name) html += `<li class="list-group-item"><span class="col-4">cognome</span> <span class="col-8">${customer.last_name}</span></li>`;
    if (customer.email) html += `<li class="list-group-item"><span class="col-4">email</span> <span class="col-8">${customer.email}</span></li>`;
    if (customer.birthday) html += `<li class="list-group-item"><span class="col-4">data di nascita</span> <span class="col-8">${customer.birthday}</span></li>`;
    if (customer.card_virtual_number) html += `<li class="list-group-item"><span class="col-4">card number</span> <span class="col-8">${customer.card_virtual_number}</span></li>`;
    if (customer.phone_home) html += `<li class="list-group-item"><span class="col-4">telefono</span> <span class="col-8">${customer.phone_home}</span></li>`;

    elementToFill.html(html);

    $('.cc-clerkUser #confirmCustomer #deleteCofirmCustomer').on('click', function (e) {
        // clearSessionStorage(['customer']);
        $('#confirmCustomer .cc-modal__close').trigger('click');
        $('#chooseCustomer .cc-modal__close').trigger('click');
    });
    $('.cc-clerkUser #confirmCustomer #continueCofirmCustomer').on('click', function (e) {
        sessionStorage.setItem('customer', JSON.stringify(customer));
        fillCustomerChoosen(customer);
        $('#confirmCustomer .cc-modal__close').trigger('click');
        $('#chooseCustomer .cc-modal__close').trigger('click');
        $('#storeAppBeginService #loginCustomer').removeAttr('disabled');
    });
}

function clearSessionStorage(keys) {
    keys.forEach(key => {
        if (sessionStorage.getItem(key)) {
            sessionStorage.removeItem(key);
        }
    });
}

function handleFormsOnLoad() {
    let disableFormObj = JSON.parse(sessionStorage.getItem('disablesearchform'));
    if (disableFormObj && disableFormObj.disabled) {
        searchForm.find('button').prop('disabled', true);
        searchForm.find('input').prop('disabled', true);
    }
}

function handleButtonsOnload() {
    let disableFormObj = JSON.parse(sessionStorage.getItem('disablesearchform'));
    if (disableFormObj && disableFormObj.disabled) {
        logoutCustomerBtn.removeClass('d-none');
        loginCustomerBtn.addClass('d-none');
    }

}

function formatDate(dateStr) {
    var date = new Date(dateStr);
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    var year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

function generateRandomString(length) {
    var upperCaseCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var specialCharacters = '!@#$%^&*()_+[]{}|;:,.<>?';
    var allCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?';

    var result = '';
    var allCharactersLength = allCharacters.length;

    // Ensure at least one uppercase letter
    result += upperCaseCharacters.charAt(Math.floor(Math.random() * upperCaseCharacters.length));

    // Ensure at least one special character
    result += specialCharacters.charAt(Math.floor(Math.random() * specialCharacters.length));

    // Generate the remaining characters
    for (var i = 2; i < length; i++) {
        result += allCharacters.charAt(Math.floor(Math.random() * allCharactersLength));
    }

    // Shuffle the result to mix the guaranteed characters
    result = result.split('').sort(function () { return 0.5 - Math.random(); }).join('');

    return result;
}

function validateForm(form){
    var isValid = true;

    form.find('input[required]').each(function() {
        var field = $(this);

        var feedbackElement = $(field).closest('.cc-form__wrap').find('.invalid-feedback');
        var divParent = $(field).closest('.cc-form__wrap');
        var selectedValue = $(field).val();
        var selectError = $(field).data('missing-error');
        var fieldName = $(field).attr('name');
        if (selectedValue !== '' && selectedValue !== undefined ) {
            feedbackElement.text('');
            removeErrorStatus(divParent, feedbackElement);
            field.removeClass('is-invalid');
            isValid = true;
        } else {
            addErrorStatus(divParent, feedbackElement);
            feedbackElement.text(selectError);
            field.addClass('is-invalid');
            isValid = false;
            // return isValid;
        }
    });


    $('#easyForm .js-form-control-storeApp-select select').each(function() {
            
        var field = $(this);

        var feedbackElement = $(field).closest('.cc-form__wrap').find('.invalid-feedback');
        var divParent = $(field).closest('.cc-form__wrap');
        var selectedValue = $(field).val();
        var selectError = $(field).data('missing-error');
        var fieldName = $(field).attr('name');
        if (selectedValue !== '' && selectedValue !== undefined ) {
            feedbackElement.text('');
            removeErrorStatus(divParent, feedbackElement);
            isValid = true;
        } else {
            addErrorStatus(divParent, feedbackElement);
            feedbackElement.text(selectError);
            isValid = false;
            // return isValid;
        }
    });

    if(phoneNumberError){
        showPhoneError();
        isValid = false;
    } 

    return isValid;
}

phoneInput.on('input', function() {
    // Get the value of the input field
    const inputVal = $(this).val();
    
    // Check if the input exceeds 12 digits
    if (inputVal.length > 12) {
        // Show the error message
        showPhoneError();
    } else {
        // Hide the error message if the input is within the limit
        hidePhoneError();
    }
});

function showPhoneError(){
    wrongPhone.addClass('d-block');
    wrongPhone.text(wrongPhone.data('errormsg'));
    phoneNumberError = true;
}

function hidePhoneError(){
    wrongPhone.removeClass('d-block');
    wrongPhone.text(''); // Clear the error message
    phoneNumberError = false;
}

function clearFormErrors(){
    wrongRegistration.addClass('d-none');
    wrongEmail.text('')
    wrongEmail.removeClass('d-block');
    wrongPhone.text('')
    wrongPhone.removeClass('d-block');
}

function addErrorStatus (divParent, feedbackElement) {
	feedbackElement.addClass('cc-message--visible');
	divParent.addClass('cc-form__wrap--error');
	divParent.find('.cc-icon--success').hide();
	divParent.find('.cc-icon--warning').hide();
	divParent.find('.cc-icon--error').show();
}

function removeErrorStatus (divParent, feedbackElement) {
	feedbackElement.removeClass('cc-message--visible');
	divParent.removeClass('cc-form__wrap--error');
	divParent.find('.cc-icon--success').show();
	divParent.find('.cc-icon--warning').hide();
	divParent.find('.cc-icon--error').hide();
}
